import axios from 'axios'

export type ResultadoPreChecagem = 'ok' | 'sessao_expirada' | 'sem_acesso' | 'falha'

/** Só um estudo na resposta abre o viewer; nenhum ou mais de um conta como sem acesso. */
export const resultadoDaPreChecagem = (estudos: unknown[]): ResultadoPreChecagem =>
  estudos.length === 1 ? 'ok' : 'sem_acesso'

export const resultadoDoErroDePreChecagem = (erro: unknown): ResultadoPreChecagem => {
  const status = axios.isAxiosError(erro) ? erro.response?.status : undefined
  if (status === 401) return 'sessao_expirada'
  if (status === 403 || status === 404) return 'sem_acesso'
  return 'falha'
}
